import { render, staticRenderFns } from "./OverlayCustomizer.vue?vue&type=template&id=f48dc982&scoped=true"
import script from "./OverlayCustomizer.vue?vue&type=script&lang=js"
export * from "./OverlayCustomizer.vue?vue&type=script&lang=js"
import style0 from "./OverlayCustomizer.vue?vue&type=style&index=0&id=f48dc982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48dc982",
  null
  
)

export default component.exports